var glide = new Glide(".inline", {
	direction: "rtl",
	autoplay: 100000,
	hoverpause: true,
	animationDuration: 1e3,
	rewindDuration: 2e3,
	touchRatio: 0.25,
	perTouch: 1,
	type: "slider",
	startAt: 1,
	perView: 3,
	// gap: 260,
	focusAt: "center",
	breakpoints: {
		960: {
			perView: 2
		},
		500: {
			perView: 2,
			gap: -140
		}
	}
});

glide.mount({
	Coverflow: function(e, t, n) {
		var i = {
			tilt: function(e) {
				e.style.opacity = "1";
				this.tiltPrevElements(e);
				this.tiltNextElements(e);
			},
			tiltPrevElements: function(e) {
				for (
					var t = (function(e) {
							var t = [];
							if (e)
								for (; (e = e.previousElementSibling); )
									t.push(e);
							return t;
						})(e),
						n = 0;
					n < t.length;
					n++
				) {
					var i = t[n];
					i.style.opacity = "0.2";
					// (i.style.transformOrigin = "100% 50%"),
					// 	(i.style.transform =
					// 		"perspective(1500px) rotateY(" +
					// 		20 * Math.max(n, 2) +
					// 		"deg)");
				}
			},
			tiltNextElements: function(e) {
				for (
					var t = (function(e) {
							var t = [];
							if (e)
								for (; (e = e.nextElementSibling); ) t.push(e);
							return t;
						})(e),
						n = 0;
					n < t.length;
					n++
				) {
					var i = t[n];
					i.style.opacity = "0.2";
					// var i = t[n].querySelector(c);
					// (i.style.transformOrigin = "0% 50%"),
					// 	(i.style.transform =
					// 		"perspective(1500px) rotateY(" +
					// 		-20 * Math.max(n, 2) +
					// 		"deg)");
				}
			}
		};
		return (
			n.on(["mount.after", "run"], function() {
				i.tilt(t.Html.slides[e.index]);
			}),
			i
		);
	}
});

var glide = new Glide(".news__carousel", {
	direction: "rtl",
	autoplay: 150000,
	hoverpause: true,
	animationDuration: 1e3,
	rewindDuration: 5000,
	touchRatio: 0.25,
	perTouch: 1,
	type: "slider",
	startAt: 0,
	perView: 2.5,
	gap: 32,
	breakpoints: {
		// 960: {
		// 	perView: 3
		// },
		640: {
			perView: 1.2
		}
	}
});

glide.mount();

$(document).ready(function() {
	var homeToMain = new TimelineMax({});

	homeToMain.fromTo(
		$(".navbar"),
		1.2,
		{ opacity: 0, y: -100, display: "none" },
		{ opacity: 1, y: 0, display: "block", ease: Power2.easeInOut },
		0.5
	);
	homeToMain.fromTo(
		$(".ham"),
		0.5,
		{ opacity: 0, top: -100 },
		{ opacity: 1, top: 20, ease: Power2.easeInOut }
	);

	homeToMain.fromTo(
		$("#mid-title"),
		1,
		{ opacity: 0, x: 30 },
		{ opacity: 1, x: 0, display: "block", ease: Power2.easeInOut },
		0.75
	);

	homeToMain.fromTo(
		$("#title"),
		1,
		{ opacity: 0, x: 100 },
		{ opacity: 1, x: 0, ease: Power2.easeInOut },
		0.5
	);

	homeToMain.fromTo(
		$(".cover"),
		2,
		{ opacity: 0, y: 100, scale: 0 },
		{ opacity: 1, y: 0, scale: 1, ease: Power2.easeInOut },
		0.8
	);

	$(function() {
		function getAreaWayPercent($block) {
			var scrollTop = $(window).scrollTop();
			var winHeight = $(window).height();
			var wayPoint = scrollTop + winHeight / 2;
			var blockTop = $block.offset().top;
			var blockHeight = $block.height();
			var blockWayPercent = Math.ceil(
				((wayPoint - blockTop) / blockHeight) * 100
			);
			blockWayPercent = blockWayPercent >= 0 ? blockWayPercent : 0;
			blockWayPercent = blockWayPercent <= 100 ? blockWayPercent : 100;
			return blockWayPercent;
		}

		function getPercentPx(start, end, percent, height) {
			return (start + end * (percent * 0.01)) * 0.01 * height;
			// return (start + end * (percent * 0.01)) * 0.01 * height;
		}

		function render() {
			var wayPercent = getAreaWayPercent($(".parallax_block"));
			var height = $(".parallax_block").height();
			TweenMax.to(".parallax_block .cover", 1, {
				ease: Power3.easeOut,
				css: {
					scale: 1 - getPercentPx(-2, 1, wayPercent, height) / 75
				}
			});

			// console.log(wayPercent, getPercentPx(-2, 10, wayPercent, height));

			// TweenMax.to(".parallax_block .projects", 1, {
			// 	ease: Power3.easeOut,
			// 	y: getPercentPx(-15, 120, wayPercent, height) + "px"
			// });
			// console.log(wayPercent + "%");
		}

		render();
		$(window).on("load resize scroll", function() {
			render();
		});

		let menuIsOpen = false;
		const menu = new TimelineMax({ paused: true, reversed: true });
		// menu.to(".menu_bar", 1, { autoAlpha: 1, display: "block" });
		menu.fromTo(
			$(".menu_bar"),
			0.5,
			{ autoAlpha: 0, y: -200, display: "none" },
			{ autoAlpha: 1, y: 0, display: "block", ease: Power2.easeInOut }
		);

		function menuIn() {
			menu.reversed() ? menu.play() : menu.reverse();
		}

		$(".ham").click(function(event) {
			$(this).toggleClass("active");
			if ($(".ham").hasClass("active")) {
				menuIsOpen = true;
			} else {
				menuIsOpen = false;
			}

			menuIn();
			event.preventDefault();
		});

		/* Outer click to document */
		$(document).on("click", function(event) {
			if (
				$(event.target).closest(".menu_bar").length !== 1 &&
				$(event.target).closest(".ham").length !== 1
			) {
				if (menuIsOpen) {
					$(".ham").removeClass("active");
					menuIn();
				}
			}
			event.stopPropagation();
		});
	});
});

window.onload = function() {
	lax.setup({
		breakpoints: { mobile: 375, medium: 960 }
	}); // init

	const updateLax = () => {
		lax.update(window.scrollY);
		window.requestAnimationFrame(updateLax);
	};

	window.requestAnimationFrame(updateLax);
};
